const prettyName = (input) => {
    if (!input) {
        return "";
    }

    let results = "";

    const words = input.split(" ");

    for (let i = 0; i < words.length; i++) {
        const word = words[i];
        let formatted = word.charAt(0).toUpperCase();
        for (let a = 1; a < word.length; a++) {
            formatted += word.charAt(a).toLowerCase();
        }

        results += formatted + " ";
    }

    return results.trim();
};

const formatPhone = (inputPhone, dialCode) => {
    let results = "";

    if (!inputPhone) {
        return results;
    }

    let input;
    if (inputPhone.includes("+")) {
        input = inputPhone.replace("+" + dialCode, "").trim();
    } else if (inputPhone.charAt(0) == dialCode) {
        input = inputPhone.substring(1, inputPhone.length);
    } else {
        input = inputPhone.trim();
    }

    try {
        let phoneFormat = "(###) ###-####";
        let phoneIndex = 0;

        for (let i = 0; i < phoneFormat.length; i++) {
            const formatChar = phoneFormat.charAt(i);

            if (formatChar == "#") {
                if (phoneIndex >= input.length) {
                    results += "0";
                }
                for (let a = phoneIndex; a < input.length; a++) {
                    phoneIndex++;
                    const charAt = input.charAt(a);

                    if (charAt >= "0" && charAt <= "9") {
                        results += charAt;
                        break;
                    }

                    if (phoneIndex == input.length) {
                        results += "0";
                    }
                }
            } else {
                results += formatChar;
            }
        }
    } catch (e) {
        console.log(e);
    }

    return results;
};

const formatMoney = (input) => {
    try {
        if (!input && input !== 0) return input;

        return parseFloat(input)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    } catch (e) {
        console.log(e);
        return input;
    }
};

export { prettyName, formatPhone, formatMoney };
